// extracted by mini-css-extract-plugin
export default {"page":"SuccessPreregistry_page__ZXfqO","wrapper":"SuccessPreregistry_wrapper__5gXdI","icon":"SuccessPreregistry_icon__23Mwi"};